import userManager from 'src/userManager';

export const LogoutPage = () => {
  userManager.signoutRedirect();
  return null;
};
